<app-header />
<div class="about" *ngFor="let data1 of aboutusdata">
  <ng-container *ngFor="let heading of head">
    <div *ngIf="heading.page === currentPage" class="text-center inline_padding1 bg_img about_top">
      <div>
        <span class="text_style_5">About us</span>
      </div>
      <div class="p-top-16">
        <span class="text_style_1" [innerHtml]="heading.page_sub_heading"></span>
      </div>
    </div>
  </ng-container>

  <div class="bg_2">
    <div class="about_grp1">
      <div class="about_grp1_inner inline_padding1">
        <div class="about_grp1_inner_left">
          <div class="text_blue_10 text_align">
            <span [innerHtml]="data1.section_1_title"></span>
          </div>
          <div class="text_style_9 text_align p-top-16 p-b-30 text_align-justify">
            <span [innerHtml]="data1.section_1_description"></span>
          </div>
          <div class="about_grp1_inner_left_bottom dis-flex-2 top-border-1 text-center">
            <div class="about_grp1_inner_left_bottom_item width_33 border_right_transparent dis-flex-3">
              <div class="about_grp1_inner_left_bottom_item_img width-50-per m-t-20 dis-flex-2">
                <img src="../../../assets/icons/leaves_icon.png" alt="icon" />
              </div>
              <div class="p-top-16 text_blue_1">AgroChem</div>
            </div>
            <div class="about_grp1_inner_left_bottom_item width_33 border_right_transparent dis-flex-3">
              <div class="about_grp1_inner_left_bottom_item_img width-50-per m-t-20 dis-flex-2">
                <img src="../../../assets/icons/pills_icon.png" alt="icon" />
              </div>
              <div class="p-top-16 text_blue_1">PharmaChem </div>
            </div>
            <div class="about_grp1_inner_left_bottom_item width_33 dis-flex-3">
              <div class="about_grp1_inner_left_bottom_item_img width-50-per m-t-20 dis-flex-2">
                <img src="../../../assets/icons/laboratory_icon.png" alt="icon" />
              </div>
              <div class="p-top-16 text_blue_1">SpecialtyChem</div>
            </div>
          </div>
        </div>
        <div class="about_grp1_inner_right p-top-45 p-l-10">
          <div class="about_grp1_inner_right_btn bg_1 dis-flex-2 z_index_1 m-r-60-neg">
            <svg class="about_grp1_inner_right_btn_play" width="64" height="64" viewBox="0 0 64 64" fill="none"
              xmlns="http://www.w3.org/2000/svg" (click)="toggleVideo()">
              <path class="play-icon"
                d="M32 0C14.3271 0 0 14.3269 0 32C0 49.6731 14.3271 64 32 64C49.6729 64 64 49.6731 64 32C64 14.3269 49.6729 0 32 0ZM40.9232 32.7877L29.4032 39.7874C29.1701 39.9289 28.9051 40 28.64 40C28.3999 40 28.1594 39.9419 27.9418 39.8243C27.484 39.5776 27.2 39.1093 27.2 38.6001V24.6006C27.2 24.0914 27.484 23.6231 27.9418 23.3763C28.3995 23.1282 28.9592 23.1432 29.4032 23.4133L40.9232 30.413C41.344 30.6694 41.6 31.1178 41.6 31.6003C41.6 32.0829 41.344 32.5314 40.9232 32.7877Z"
                fill="#0032A0" />
            </svg>
          </div>
          <div class="about_grp1_inner_right_video">
            <video class="about_grp1_inner_right_video_link" width="100%" height="100%" #aboutVideo
              [poster]="getMediaUrl(data1.section_1_thumbnail, 'about-us')">
              <source [src]="getMediaUrl(data1.section_1_video, 'about-us')" type="video/mp4" />
            </video>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="about_grp2 text-start">
    <div class="bg_3">
      <div class="about_grp2_cols inline_padding1">
        <div class="about_grp2_cols_item">
          <div>
            <svg width="104" height="110" viewBox="0 0 104 110" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g filter="url(#filter0_d_619_16649)">
                <path
                  d="M51.5 20C50.1263 20 48.78 20.3554 47.5848 21.039L23.9152 34.6411C21.4974 36.0355 20 38.6056 20 41.3944V68.5988C20 71.3876 21.4974 73.9576 23.9152 75.352L47.5848 88.9542C50.0026 90.3486 52.9974 90.3486 55.4152 88.9542L80.0848 75.352C82.5026 73.9576 84 71.3876 84 68.5988V41.3944C84 38.6056 82.5026 36.0355 80.0848 34.6411L55.4152 21.039C54.22 20.3554 52.8738 20 51.5 20Z"
                  fill="#F8FAFF" />
                <path
                  d="M48.584 87.2217L48.5813 87.2201L24.9144 73.6195C24.9137 73.6191 24.9131 73.6188 24.9124 73.6184C23.1093 72.5776 22 70.6653 22 68.5988V41.3944C22 39.3278 23.1093 37.4155 24.9126 36.3747C24.9132 36.3744 24.9138 36.374 24.9144 36.3737L48.5777 22.7751C48.5784 22.7747 48.579 22.7744 48.5796 22.774C49.4703 22.2651 50.4734 22 51.5 22C52.5274 22 53.5311 22.2654 54.4223 22.7751L54.4358 22.7828L54.4495 22.7904L79.1011 36.3826C80.8963 37.4252 82 39.333 82 41.3944V68.5988C82 70.6602 80.8963 72.568 79.1011 73.6106L54.4495 87.2028L54.4327 87.2121L54.416 87.2217C52.6166 88.2594 50.3834 88.2594 48.584 87.2217Z"
                  stroke="white" stroke-width="4" />
              </g>
              <path
                d="M50.7338 38.5334C40.9397 38.5334 33 46.4729 33 56.2666C33 66.0605 40.9397 73.9999 50.7338 73.9999C60.5279 73.9999 68.4677 66.0605 68.4677 56.2666C68.4677 53.8855 67.9973 51.6145 67.1461 49.5403L66.9879 49.6986C66.5744 50.112 66.0305 50.3703 65.4484 50.4283L63.5181 50.6207C64.2817 52.3471 64.7067 54.2569 64.7067 56.2662C64.7067 63.9829 58.4508 70.2385 50.7339 70.2385C43.0169 70.2385 36.7611 63.9829 36.7611 56.2662C36.7611 48.5495 43.0169 42.294 50.7338 42.294C52.7424 42.294 54.6515 42.7187 56.3776 43.4817L56.5699 41.5531C56.628 40.971 56.8872 40.4265 57.3007 40.013L57.4592 39.8545C55.385 39.0037 53.1145 38.5334 50.7338 38.5334ZM50.7338 51.2001C51.1872 51.2001 51.6265 51.26 52.0446 51.3717L48.9417 54.475C47.9539 55.4628 47.9543 57.0674 48.9404 58.0564C49.4161 58.5334 50.0603 58.8 50.7338 58.8C51.4067 58.8 52.0501 58.5335 52.526 58.0575L55.6286 54.9544C55.7405 55.373 55.8005 55.8128 55.8005 56.2666C55.8005 59.0648 53.532 61.3333 50.7337 61.3333C47.9354 61.3333 45.6669 59.0648 45.6669 56.2666C45.6671 53.4685 47.9355 51.2001 50.7338 51.2001ZM50.7338 44.8273C52.6771 44.8273 54.5069 45.3125 56.1097 46.1674L55.9836 47.4323L54.0091 49.407C53.0172 48.9326 51.9066 48.6667 50.7338 48.6667C46.5364 48.6667 43.1337 52.0693 43.1337 56.2666C43.1337 60.4639 46.5364 63.8664 50.7338 63.8664C54.9313 63.8664 58.3339 60.4639 58.3339 56.2666C58.3339 55.0931 58.0678 53.9819 57.5928 52.9897L59.5678 51.0144L60.8319 50.8884C61.6877 52.4914 62.1732 54.3221 62.1732 56.2662C62.1732 62.5838 57.0516 67.7053 50.7338 67.7053C44.416 67.7053 39.2944 62.5839 39.2944 56.2662C39.2944 49.9485 44.416 44.8273 50.7338 44.8273Z"
                fill="#0032A0" />
              <path
                d="M57.2003 48.0082L57.8314 41.6789C57.8614 41.3875 57.9921 41.1161 58.1975 40.9088L62.7356 36.3707C63.0866 36.0219 63.6058 35.9069 64.0689 36.0787C64.5321 36.2497 64.857 36.6751 64.8944 37.1674L65.2529 41.7471L69.8357 42.1073C70.325 42.1461 70.7508 42.4676 70.9226 42.9315C71.0945 43.3953 70.9787 43.9163 70.6313 44.2655L66.0933 48.8032C65.8878 49.0106 65.6152 49.1389 65.3239 49.1682L58.993 49.7992L51.6313 57.1623C51.3848 57.4093 51.0599 57.5336 50.7349 57.5336C50.41 57.5336 50.085 57.4093 49.8385 57.1623C49.3455 56.6676 49.3455 55.8657 49.8385 55.3709L57.2003 48.0082Z"
                fill="#FFCD04" />
              <defs>
                <filter id="filter0_d_619_16649" x="0" y="0" width="104" height="110" filterUnits="userSpaceOnUse"
                  color-interpolation-filters="sRGB">
                  <feFlood flood-opacity="0" result="BackgroundImageFix" />
                  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha" />
                  <feOffset />
                  <feGaussianBlur stdDeviation="10" />
                  <feComposite in2="hardAlpha" operator="out" />
                  <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0" />
                  <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_619_16649" />
                  <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_619_16649" result="shape" />
                </filter>
              </defs>
            </svg>
          </div>
          <div>
            <div>
              <span class="text_white_5_res">Our Mission</span>
            </div>
            <div>
              <span class="text_white_11 text_align-justify" [innerHtml]="data1.section_2_mission_des"></span>
            </div>
          </div>
        </div>
        <div class="about_grp2_cols_item">
          <div>
            <svg width="104" height="110" viewBox="0 0 104 110" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g filter="url(#filter0_d_619_16632)">
                <path
                  d="M51.5 20C50.1263 20 48.78 20.3554 47.5848 21.039L23.9152 34.6411C21.4974 36.0355 20 38.6056 20 41.3944V68.5988C20 71.3876 21.4974 73.9576 23.9152 75.352L47.5848 88.9542C50.0026 90.3486 52.9974 90.3486 55.4152 88.9542L80.0848 75.352C82.5026 73.9576 84 71.3876 84 68.5988V41.3944C84 38.6056 82.5026 36.0355 80.0848 34.6411L55.4152 21.039C54.22 20.3554 52.8738 20 51.5 20Z"
                  fill="#F8FAFF" />
                <path
                  d="M48.584 87.2217L48.5813 87.2201L24.9144 73.6195C24.9137 73.6191 24.9131 73.6188 24.9124 73.6184C23.1093 72.5776 22 70.6653 22 68.5988V41.3944C22 39.3278 23.1093 37.4155 24.9126 36.3747C24.9132 36.3744 24.9138 36.374 24.9144 36.3737L48.5777 22.7751C48.5784 22.7747 48.579 22.7744 48.5796 22.774C49.4703 22.2651 50.4734 22 51.5 22C52.5274 22 53.5311 22.2654 54.4223 22.7751L54.4358 22.7828L54.4495 22.7904L79.1011 36.3826C80.8963 37.4252 82 39.333 82 41.3944V68.5988C82 70.6602 80.8963 72.568 79.1011 73.6106L54.4495 87.2028L54.4327 87.2121L54.416 87.2217C52.6166 88.2594 50.3834 88.2594 48.584 87.2217Z"
                  stroke="white" stroke-width="4" />
              </g>
              <path
                d="M45.8207 66.6729C45.7996 66.8835 45.8177 67.1034 45.8943 67.3213C46.0813 67.8467 46.52 68.2747 47.0397 68.436C47.5226 68.589 48.003 68.4872 48.1488 68.3283L49.1563 67.2446C49.4478 66.9322 49.5214 66.4329 49.3502 65.9483C48.9286 65.1386 48.3637 64.8464 47.6404 64.7156L45.8207 66.6729Z"
                fill="#0032A0" />
              <path
                d="M44.4737 61.2545L42.7129 63.1474C42.3551 63.5375 42.2526 64.1371 42.4523 64.7117C42.6643 65.3188 43.1703 65.8126 43.7759 65.9971C44.3491 66.1693 44.9242 66.0355 45.2844 65.6513L46.9147 63.8986C47.2749 63.5095 47.375 62.9127 47.1753 62.3382C46.9633 61.7282 46.4544 61.2363 45.8517 61.0528C45.3708 60.8988 44.8064 60.8929 44.4737 61.2545Z"
                fill="#0032A0" />
              <path
                d="M40.9825 58.1397L39.3567 59.8895C38.9984 60.2766 38.8983 60.8782 39.0961 61.4548C39.3081 62.0598 39.814 62.5537 40.4196 62.7382C40.9919 62.9128 41.5729 62.7766 41.754 62.5842L43.559 60.6426C43.9192 60.2525 44.0193 59.6528 43.8196 59.0793C43.6066 58.4703 43.1006 57.9783 42.495 57.7958C41.938 57.6138 41.3216 57.7757 40.9825 58.1397Z"
                fill="#0032A0" />
              <path
                d="M37.8046 54.6902L36.0025 56.6328C35.6423 57.0219 35.5422 57.6186 35.7419 58.1902C35.952 58.8022 36.4609 59.2941 37.0665 59.4786C37.6387 59.6498 38.2188 59.5169 38.3979 59.3221L40.2048 57.3805V57.3785C40.565 56.9943 40.6652 56.3967 40.4654 55.8231C40.2564 55.2111 39.7474 54.7192 39.1419 54.5367C38.6791 54.3768 38.1191 54.3493 37.8046 54.6902Z"
                fill="#0032A0" />
              <path
                d="M61.198 43.105C60.0325 43.7583 58.4125 43.8753 56.8348 43.989C55.6413 44.0706 54.41 44.1572 53.5251 44.4848L48.6054 46.3045C48.572 46.3177 48.5381 46.3256 48.5028 46.3305C48.2653 46.3679 48.0454 46.3999 47.8481 46.4274C46.6502 46.5967 46.5118 46.6483 46.3739 47.004C46.2483 47.3326 46.3862 47.8063 46.7268 48.2087C47.0045 48.5393 48.0915 49.5713 50.3279 49.0405L53.1296 48.6696C54.6985 48.467 55.9563 49.4921 56.9609 50.3196L64.4954 56.3614L64.5013 56.3584C65.9907 55.7337 67.5425 54.921 68.8616 53.3282L61.198 43.105Z"
                fill="#0032A0" />
              <path
                d="M50.8301 42.7381C50.3836 42.7794 49.8717 42.836 49.3348 42.892C46.3653 43.2098 44.7188 43.3348 43.8811 43.1793L36.1719 53.2377C36.4555 53.5068 36.6906 53.7862 36.88 54.0887C37.5244 53.4276 38.498 53.1915 39.4462 53.4788C40.3766 53.7601 41.1535 54.5162 41.4784 55.4543C41.6163 55.8513 41.6595 56.2586 41.6241 56.6487C42.0045 56.5951 42.4064 56.6172 42.8019 56.7383C43.7299 57.0177 44.5097 57.7757 44.8322 58.7138C44.972 59.1088 45.0162 59.5152 44.9828 59.9053C45.3632 59.8517 45.7651 59.8743 46.1606 59.9978C47.0867 60.2791 47.8631 61.0352 48.1879 61.9684C48.3921 62.5602 48.3999 63.1692 48.2341 63.7152C48.3288 63.7334 48.4259 63.7565 48.5226 63.7871C49.3535 64.0453 50.0592 64.7296 50.3629 65.5732C50.6525 66.3898 50.5269 67.2477 50.0513 67.8636L51.419 68.9601C51.7537 69.2263 52.2415 69.2553 52.697 69.0339C53.1907 68.7939 53.5636 68.3064 53.6736 67.7608C53.7197 67.5331 53.7045 67.3122 53.6525 67.1075L51.9176 65.7164C51.6845 65.529 51.6433 65.1831 51.8254 64.9431C52.0094 64.705 52.3471 64.6607 52.5816 64.8481L54.6673 66.5236C54.8744 66.6899 55.4677 66.7342 56.012 66.4774C56.5842 66.2034 57.0166 65.6387 57.1363 65.0085C57.2511 64.4128 57.0671 63.8353 56.6578 63.5047L54.7714 61.9915C54.5363 61.8041 54.4951 61.4573 54.6791 61.2202C54.8612 60.9791 55.2008 60.9349 55.4334 61.1252L58.1757 63.3237C58.5879 63.6523 59.1803 63.6975 59.7275 63.4417C60.2948 63.1697 60.7271 62.6059 60.8498 61.9689C60.9647 61.3732 60.7806 60.7976 60.3669 60.4641L57.6236 58.2686C57.3885 58.0792 57.3473 57.7334 57.5314 57.4914C57.7154 57.2543 58.053 57.213 58.2886 57.3999C58.2886 57.3999 62.4541 60.7386 62.457 60.7386C62.6641 60.9019 63.2545 60.9482 63.7963 60.6884C64.3695 60.4203 64.7989 59.8566 64.9236 59.2215C65.0364 58.6248 64.8524 58.0453 64.4406 57.7177L56.2878 51.1775C55.3524 50.4087 54.3861 49.6122 53.2638 49.7633L50.5185 50.1224C48.6679 50.568 46.9223 50.1273 45.9128 48.9309C45.3043 48.2102 45.0972 47.3189 45.3705 46.6021C45.7538 45.608 46.488 45.5051 47.6996 45.334C47.8807 45.3108 48.0756 45.2823 48.29 45.2484L53.1592 43.4479C53.4758 43.3299 53.8262 43.2482 54.1888 43.1759C52.9369 42.6904 52.0295 42.6613 50.8301 42.7381Z"
                fill="#FFCD04" />
              <path
                d="M40.2476 40.8318C39.3609 40.7644 38.5511 41.4344 37.3856 42.9559L34.4048 46.848C33.3266 48.252 32.9227 49.1251 33.012 49.865C33.0836 50.473 33.5057 51.0697 33.9243 51.4062L35.3382 52.5381L43.016 42.521L42.0222 41.7236C41.3391 41.1776 40.7796 40.8731 40.2476 40.8318Z"
                fill="#FFCD04" />
              <path
                d="M64.8676 40.8214C64.3356 40.8549 63.7712 41.153 63.0827 41.6911L62.0781 42.4723L69.6494 52.571L70.628 51.8081C71.4745 51.1499 71.9064 50.561 71.9854 49.9535C72.0831 49.2156 71.692 48.3356 70.6309 46.9134L67.6987 42.9839C66.5562 41.4466 65.7568 40.7643 64.8676 40.8214Z"
                fill="#0032A0" />
              <defs>
                <filter id="filter0_d_619_16632" x="0" y="0" width="104" height="110" filterUnits="userSpaceOnUse"
                  color-interpolation-filters="sRGB">
                  <feFlood flood-opacity="0" result="BackgroundImageFix" />
                  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha" />
                  <feOffset />
                  <feGaussianBlur stdDeviation="10" />
                  <feComposite in2="hardAlpha" operator="out" />
                  <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0" />
                  <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_619_16632" />
                  <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_619_16632" result="shape" />
                </filter>
              </defs>
            </svg>
          </div>
          <div>
            <div>
              <span class="text_white_5_res">What We Offer</span>
            </div>
            <div>
              <span class="text_white_11 text_align-justify" [innerHtml]="data1.section_2_offer_des"></span>
            </div>
          </div>
        </div>
        <div class="about_grp2_cols_item">
          <div>
            <svg width="104" height="110" viewBox="0 0 104 110" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g filter="url(#filter0_d_619_16660)">
                <path
                  d="M51.5 20C50.1263 20 48.78 20.3554 47.5848 21.039L23.9152 34.6411C21.4974 36.0355 20 38.6056 20 41.3944V68.5988C20 71.3876 21.4974 73.9576 23.9152 75.352L47.5848 88.9542C50.0026 90.3486 52.9974 90.3486 55.4152 88.9542L80.0848 75.352C82.5026 73.9576 84 71.3876 84 68.5988V41.3944C84 38.6056 82.5026 36.0355 80.0848 34.6411L55.4152 21.039C54.22 20.3554 52.8738 20 51.5 20Z"
                  fill="#F8FAFF" />
                <path
                  d="M48.584 87.2217L48.5813 87.2201L24.9144 73.6195C24.9137 73.6191 24.9131 73.6188 24.9124 73.6184C23.1093 72.5776 22 70.6653 22 68.5988V41.3944C22 39.3278 23.1093 37.4155 24.9126 36.3747C24.9132 36.3744 24.9138 36.374 24.9144 36.3737L48.5777 22.7751C48.5784 22.7747 48.579 22.7744 48.5796 22.774C49.4703 22.2651 50.4734 22 51.5 22C52.5274 22 53.5311 22.2654 54.4223 22.7751L54.4358 22.7828L54.4495 22.7904L79.1011 36.3826C80.8963 37.4252 82 39.333 82 41.3944V68.5988C82 70.6602 80.8963 72.568 79.1011 73.6106L54.4495 87.2028L54.4327 87.2121L54.416 87.2217C52.6166 88.2594 50.3834 88.2594 48.584 87.2217Z"
                  stroke="white" stroke-width="4" />
              </g>
              <path
                d="M60.76 53.9423C60.2649 49.9026 57.0766 46.7223 53.0356 46.2374C52.6877 46.1977 52.3378 46.1777 51.9876 46.1777C48.4163 46.1832 45.2007 48.3415 43.8426 51.6445C42.4846 54.9474 43.2521 58.7434 45.7867 61.2594C47.1345 62.5501 47.9063 64.3288 47.9284 66.1949V67.2141H56.0712V66.1896C56.0774 64.3589 56.8222 62.6081 58.1368 61.3339C60.1224 59.4181 61.0938 56.6812 60.76 53.9423Z"
                fill="#FFCD04" />
              <path
                d="M51.9975 74C52.8599 73.999 53.6285 73.4556 53.9169 72.6428H50.0781C50.3665 73.4556 51.1351 73.999 51.9975 74Z"
                fill="#FFCD04" />
              <path
                d="M48.6094 70.6073C48.6099 70.9819 48.9134 71.2853 49.288 71.2859H54.7165C55.0911 71.2853 55.3946 70.9819 55.3951 70.6073V68.5715H48.6094V70.6073Z"
                fill="#FFCD04" />
              <path
                d="M51.9978 42.1072C52.7473 42.1072 53.355 41.4995 53.355 40.75V37.3572C53.355 36.6076 52.7473 36 51.9978 36C51.2483 36 50.6406 36.6076 50.6406 37.3572V40.75C50.6406 41.4995 51.2483 42.1072 51.9978 42.1072Z"
                fill="#303030" />
              <path
                d="M40.5465 45.4659C41.0835 45.9788 41.9289 45.9788 42.4659 45.4659C42.7205 45.2114 42.8635 44.8661 42.8635 44.5061C42.8635 44.1462 42.7205 43.8009 42.4659 43.5464L40.0667 41.1476C39.8122 40.893 39.4671 40.75 39.1072 40.75C38.7473 40.75 38.4021 40.893 38.1476 41.1476C37.893 41.402 37.75 41.7472 37.75 42.1072C37.75 42.4671 37.893 42.8122 38.1476 43.0667L40.5465 45.4659Z"
                fill="#303030" />
              <path
                d="M39.1072 55C39.1072 54.2505 38.4995 53.6428 37.75 53.6428H34.3572C33.6079 53.6436 33.0007 54.2507 33 55C33.0007 55.7492 33.6079 56.3564 34.3572 56.3572H37.75C38.4995 56.3572 39.1072 55.7495 39.1072 55Z"
                fill="#303030" />
              <path
                d="M41.8584 64.1808C41.3893 64.0555 40.8891 64.1902 40.5464 64.5342L38.1476 66.9334C37.893 67.1878 37.75 67.533 37.75 67.8929C37.75 68.2529 37.893 68.598 38.1476 68.8525C38.6845 69.3654 39.5298 69.3654 40.0667 68.8525L42.4659 66.4537C42.8098 66.111 42.9446 65.6108 42.8192 65.1417C42.6939 64.6727 42.3274 64.3062 41.8584 64.1808Z"
                fill="#303030" />
              <path
                d="M63.4516 64.5342C63.1089 64.1902 62.6087 64.0555 62.1396 64.1808C61.6706 64.3062 61.3042 64.6725 61.1789 65.1416C61.0535 65.6106 61.1882 66.1109 61.5322 66.4535L63.9314 68.8524C64.4683 69.3653 65.3136 69.3653 65.8505 68.8524C66.1051 68.5979 66.2481 68.2527 66.2481 67.8928C66.2481 67.5328 66.1051 67.1877 65.8505 66.9332L63.4516 64.5342Z"
                fill="#303030" />
              <path
                d="M69.6406 53.6428H66.2478C65.4983 53.6428 64.8906 54.2505 64.8906 55C64.8906 55.7495 65.4983 56.3572 66.2478 56.3572H69.6406C70.3902 56.3572 70.9978 55.7495 70.9978 55C70.9978 54.2505 70.3902 53.6428 69.6406 53.6428Z"
                fill="#303030" />
              <path
                d="M63.4538 45.4658L65.8527 43.0666C66.1955 42.7238 66.3294 42.2242 66.2039 41.7559C66.0784 41.2875 65.7126 40.9218 65.2443 40.7963C64.776 40.6708 64.2763 40.8047 63.9335 41.1475L61.5343 43.5463C61.2797 43.8008 61.1367 44.1461 61.1367 44.506C61.1367 44.866 61.2797 45.2113 61.5343 45.4658C62.0714 45.9788 62.9169 45.9788 63.4538 45.4658Z"
                fill="#303030" />
              <defs>
                <filter id="filter0_d_619_16660" x="0" y="0" width="104" height="110" filterUnits="userSpaceOnUse"
                  color-interpolation-filters="sRGB">
                  <feFlood flood-opacity="0" result="BackgroundImageFix" />
                  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha" />
                  <feOffset />
                  <feGaussianBlur stdDeviation="10" />
                  <feComposite in2="hardAlpha" operator="out" />
                  <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0" />
                  <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_619_16660" />
                  <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_619_16660" result="shape" />
                </filter>
              </defs>
            </svg>
          </div>
          <div>
            <div>
              <span class="text_white_5_res">Our Vision</span>
            </div>
            <div>
              <span class="text_white_11 text_align-justify" [innerHtml]="data1.section_2_vision_des"></span>
            </div>
          </div>
        </div>
      </div>
      <div class="about_grp2_bottom1 inline_padding1 bg_3">
        <div class="">
          <div class="about_grp2_bottom1_box">
            <div class="about_grp2_bottom1_box_item dis-flex-3">
              <div>
                <p class="text-blue_res_1">
                  {{ data1.section_2_project_counts }}+
                </p>
              </div>
              <div>
                <span class="text_black_11">Projects Delivered</span>
              </div>
            </div>
          </div>
        </div>
        <div class="dis-flex-1">
          <div class="about_grp2_bottom1_box">
            <div class="about_grp2_bottom1_box_item">
              <div>
                <p class="text-blue_res_1">
                  {{ data1.section_2_client_counts }}+
                </p>
              </div>
              <div>
                <span class="text_black_11">Clients</span>
              </div>
            </div>
          </div>
        </div>
        <div class="dis-flex-1">
          <div class="about_grp2_bottom1_box">
            <div class="about_grp2_bottom1_box_item dis-flex-3">
              <div>
                <p class="text-blue_res_1">
                  {{ data1.section_2_countries_counts }}+
                </p>
              </div>
              <div>
                <span class="text_black_11">Countries</span>
              </div>
            </div>
          </div>
        </div>
        <div class="dis-flex-1">
          <div class="about_grp2_bottom1_box">
            <div class="about_grp2_bottom1_box_item dis-flex-3">
              <div>
                <p class="text-blue_res_1">
                  {{ data1.section_2_industry_counts }}+
                </p>
              </div>
              <div class="text-wrap text-center">
                <span class="text_black_11">Specialized Industry Focus</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="about_grp2_bottom2 inline_padding1 bg_2">
      <div class="dis-flex-1">
        <div class="about_grp2_bottom2_box">
          <div class="about_grp2_bottom2_box_item dis-flex-3">
            <div>
              <p class="text_blue_13">{{ data1.section_2_project_counts }}+</p>
            </div>
            <div>
              <span class="text_black_11">Projects Delivered</span>
            </div>
          </div>
        </div>
      </div>
      <div class="dis-flex-1">
        <div class="about_grp2_bottom2_box">
          <div class="about_grp2_bottom2_box_item">
            <div>
              <p class="text_blue_13">{{ data1.section_2_client_counts }}+</p>
            </div>
            <div>
              <span class="text_black_11">Clients</span>
            </div>
          </div>
        </div>
      </div>
      <div class="dis-flex-1">
        <div class="about_grp2_bottom2_box">
          <div class="about_grp2_bottom2_box_item dis-flex-3">
            <div>
              <p class="text_blue_13">
                {{ data1.section_2_countries_counts }}+
              </p>
            </div>
            <div>
              <span class="text_black_11">Countries</span>
            </div>
          </div>
        </div>
      </div>
      <div class="dis-flex-1">
        <div class="about_grp2_bottom2_box">
          <div class="about_grp2_bottom2_box_item dis-flex-3">
            <div>
              <p class="text_blue_13">{{ data1.section_2_industry_counts }}+</p>
            </div>
            <div>
              <span class="text_black_11">Specialized Industry Focus</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="about_grp3 inline_padding1 text-start bg_2">
    <div>
      <span class="text_style_5 text_align-justify" [innerHtml]="data1.section_2_info_title">
      </span>
    </div>
    <div class="p-top-32">
      <p class="text_style_1 text_align-justify" [innerHtml]="data1.section_2_info_description"></p>
    </div>
    <div class="share-buttons" style="margin-top:15px;">
      <button (click)="copyLink()" style="background: transparent; border: none; cursor: pointer;">
        <i class="fas fa-link" style="color: #000;"></i> <!-- Copy Link -->
      </button>
      <button (click)="shareViaEmail()" style="background: transparent; border: none; cursor: pointer;">
        <i class="fas fa-envelope" style="color: #EA4335;"></i> <!-- Email -->
      </button>
      <button (click)="shareViaSMS()" style="background: transparent; border: none; cursor: pointer;">
        <i class="fas fa-sms" style="color: #25D366;"></i> <!-- SMS -->
      </button>
      <button (click)="shareViaWhatsApp()" style="background: transparent; border: none; cursor: pointer;">
        <i class="fab fa-whatsapp" style="color: #25D366;"></i> <!-- WhatsApp -->
      </button>
      <button (click)="shareViaMessenger()" style="background: transparent; border: none; cursor: pointer;">
        <i class="fab fa-facebook-messenger" style="color: #0084FF;"></i> <!-- Messenger -->
      </button>
      <button (click)="shareViaViber()" style="background: transparent; border: none; cursor: pointer;">
        <i class="fab fa-viber" style="color: #59267C;"></i> <!-- Viber -->
      </button>
      <button (click)="shareViaFacebook()" style="background: transparent; border: none; cursor: pointer;">
        <i class="fab fa-facebook" style="color: #4267B2;"></i> <!-- Facebook -->
      </button>
      <button (click)="shareViaTwitter()" style="background: transparent; border: none; cursor: pointer;">
        <i class="fab fa-twitter" style="color: #1DA1F2;"></i> <!-- Twitter -->
      </button>
      <button (click)="shareViaLinkedIn()" style="background: transparent; border: none; cursor: pointer;">
        <i class="fab fa-linkedin" style="color: #0077B5;"></i> <!-- LinkedIn -->
      </button>
      <button (click)="shareViaPinterest()" style="background: transparent; border: none; cursor: pointer;">
        <i class="fab fa-pinterest" style="color: #E60023;"></i> <!-- Pinterest -->
      </button>
      <button (click)="shareViaReddit()" style="background: transparent; border: none; cursor: pointer;">
        <i class="fab fa-reddit" style="color: #FF4500;"></i> <!-- Reddit -->
      </button>
      <button (click)="shareViaTumblr()" style="background: transparent; border: none; cursor: pointer;">
        <i class="fab fa-tumblr" style="color: #35465C;"></i> <!-- Tumblr -->
      </button>
      <button (click)="shareViaTelegram()" style="background: transparent; border: none; cursor: pointer;">
        <i class="fab fa-telegram" style="color: #0088CC;"></i> <!-- Telegram -->
      </button>
      <button (click)="shareViaVK()" style="background: transparent; border: none; cursor: pointer;">
        <i class="fab fa-vk" style="color: #4B7BE5;"></i> <!-- VK -->
      </button>
      <button (click)="shareViaMix()" style="background: transparent; border: none; cursor: pointer;">
        <i class="fab fa-mix" style="color: #00A3E0;"></i> <!-- Mix -->
      </button>
      <button (click)="shareViaXing()" style="background: transparent; border: none; cursor: pointer;">
        <i class="fab fa-xing" style="color: #006567;"></i> <!-- Xing -->
      </button>
      <button (click)="shareViaLine()" style="background: transparent; border: none; cursor: pointer;">
        <i class="fab fa-line" style="color: #00B900;"></i> <!-- Line -->
      </button>

    </div>
  </div>
  <div class="bg_2 p-top-220">
    <div class="about_director">
      <div class="text-center bg_3">
        <div class="about_director_body p-b-200 inline_padding1">
          <div class="p-x-50">
            <div class="dis-flex-1">
              <div class="m-t-200-neg">
                <span class="text_style_5">Our Directors</span>
              </div>
            </div>
            <div class="about_director_body_info1 m-t-200-neg">
              <ng-container *ngFor="let director of data1.directorsArr">
                <div class="p-top-40">
                  <div>
                    <img class="about_director_body_info1_img border-radius-20 image_width4 border-6"
                      [src]="getMediaUrl(director.image, 'about-us')" alt="{{ director.name }}" />
                  </div>
                  <div class="p-top-32">
                    <span class="text_white_12" [innerHtml]="director.name"></span>
                  </div>
                  <div class="p-top-20">
                    <span class="text_white_13" [innerHtml]="director.heading"></span>
                  </div>
                  <div class="p-top-40 dis-flex-1">
                    <div class="p-x-10">
                      <div class="about_director_body_info1_icon bg_1 border-radius-50-per dis-flex-2">
                        <img src="../../../assets/icons/scholar_icon.png" />
                      </div>
                    </div>
                    <div class="p-x-10">
                      <div class="about_director_body_info1_icon bg_1 border-radius-50-per dis-flex-2">
                        <img src="../../../assets/icons/linkedin.png" />
                      </div>
                    </div>

                  </div>

                </div>
              </ng-container>
            </div>
            <div class="about_director_body_info2 m-t-200-neg p-x-50 p-top-120">
              <ng-container *ngFor="let director of data1.directorsArr">
                <div class="width-50-per p-x-50">
                  <div>
                    <img class="about_director_body_info2_img border-radius-20 image_width4 border-6"
                      [src]="getMediaUrl(director.image, 'about-us')" alt="{{ director.name }}" />
                  </div>
                  <div class="p-top-32">
                    <span class="text_white_12" [innerHtml]="director.name"></span>
                  </div>
                  <div class="p-top-20">
                    <span class="text_white_13" [innerHtml]="director.bio"></span>
                  </div>
                  <div class="p-top-40 dis-flex-1">
                    <div class="p-x-10">
                      <div class="about_director_body_info2_icon bg_1 border-radius-50-per dis-flex-2">
                        <a [href]="director.google_scolar_url" target="_blank">
                          <img src="../../../assets/icons/scholar_icon.png" alt="Google Scholar" />
                        </a>
                      </div>
                    </div>
                    <div class="p-x-10">
                      <div class="about_director_body_info2_icon bg_1 border-radius-50-per dis-flex-2">
                        <a [href]="director.linkdin_url" target="_blank">
                          <img src="../../../assets/icons/linkedin.png" alt="LinkedIn" />
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </ng-container>
            </div>
          </div>
          <div class="p-top-80">
            <div>
              <span class="text_white_6_res">Our Top 5 Partners</span>
            </div>
            <div class="p-top-16">
              <span class="text_white_14 text_align-justify">ChemRobotics® Welcomes Strategic Partners for Mutual
                Collaboration and Partnership
              </span>
            </div>
          </div>
        </div>
        <div class="about_director_bottom1 inline_padding1 bg_3">
          <ng-container *ngFor="let partner of partners | slice:0:5">
            <div class="about_director_bottom1_item">
              <img [src]="getMediaUrl($any(partner).logo_1, 'partners')" alt="logo" class="width-70-per" />
            </div>
          </ng-container>
        </div>
        <div class="about_director_bottom2 inline_padding1 bg_2">
          <ng-container *ngFor="let partner of partners | slice:0:5">
            <div class="about_director_bottom2_item">
              <img [src]="getMediaUrl($any(partner).logo_1, 'partners')" alt="logo" class="width-70-per" />
            </div>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
  <div class="text-center bg_1">
    <div class="about_grp5 bg_2 inline_padding1 text_align">
      <span class="text_style_5">Awarded The Certificate</span>
      <div class="p-top-16">
        <article class="text_style_9 text_align-justify">
          On the other hand, we denounce with righteous indignation and dislike
          men who are so beguiled and demoralized by the charms of pleasure of
          the moment, so blinded by desire, that they cannot foresee the pain
          and trouble that are bound to ensue; and equal blame belongs to those
          who fail in their duty through weakness of will, which is the same as
          saying through shrinking from toil and pain. These cases are perfectly
          simple and easy to distinguish.
        </article>
      </div>
      <div class="about_grp5_body p-top-40">
        <div class="about_grp5_body p-top-40">
          <ng-container *ngFor="let award of awarding; let i = index">
            <div class="about_grp5_body_item p-bot-16">
              <img class="width-100-per" [src]="getMediaUrl(award.award_image, 'awards')" alt="certificate" />
              <div class="about_grp5_body_item_bottom p-top-32">
                <span class="text_blue_8">
                  {{
                  award.awardee?.length > 30
                  ? award.awardee.slice(0, 30) + "..."
                  : award.awardee
                  }}
                </span>
                <div class="p-top-8">
                  <span class="text_black_4_res">{{ award.date | date: 'dd MMM yyyy' }} |
                    {{ award.award_title?.slice(0, 100) }}</span>
                </div>

                <div *ngIf="award.web_link" class="p-top-12">
                  <button type="button" class="rounded-pill text_white_1 button_blue_7"
                    (click)="openLink(award.web_link)"
                    style="width: 150px; padding: 12px 24px; display: flex; justify-content: space-between; align-items: center;">
                    <span class="button_blue_1_text" style="font-size: 16px;">Weblink</span>
                    <img class="button_blue_1_text_icon" src="../../../assets/icons/arrow-right.png"
                      style="height: 70%; max-width: none; object-fit: contain;" />
                  </button>
                </div>






                <!-- <div
                  (click)="toggleReadMore(i)"
                  class="text_blue_14 cursor-pointer"
                >
                  {{ readMoreState[i] ? "Read Less" : "Read More" }}
                </div> -->
              </div>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</div>

<app-footer />